"use strict";

var modal = _interopRequireWildcard(require("makeup-modal"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// REQUIRE
// const modal = require('makeup-modal');

// IMPORT

const modal1 = document.getElementById("modal-1");
const modal2 = document.getElementById("modal-2");
const modal3 = document.getElementById("modal-3");
const button1 = document.getElementById("button-1");
const button2 = document.getElementById("button-2");
const button3 = document.getElementById("button-3");
const unmodalButton = document.getElementById("button-unmodal");
const hoistCheckbox = document.getElementById("hoist-checkbox");
const wrapCheckbox = document.getElementById("wrap-checkbox");
const hiddenCheckbox = document.getElementById("hidden-checkbox");
modal1.addEventListener("makeup-modal", e => console.log(e));
modal2.addEventListener("makeup-modal", e => console.log(e));
modal3.addEventListener("makeup-modal", e => console.log(e));
modal1.addEventListener("makeup-unmodal", e => console.log(e));
modal2.addEventListener("makeup-unmodal", e => console.log(e));
modal3.addEventListener("makeup-unmodal", e => console.log(e));
button1.addEventListener("click", () => {
  modal.modal(modal1, {
    hoist: hoistCheckbox.checked,
    useHiddenProperty: hiddenCheckbox.checked,
    wrap: wrapCheckbox.checked
  });
});
button2.addEventListener("click", () => {
  modal.modal(modal2, {
    hoist: hoistCheckbox.checked,
    useHiddenProperty: hiddenCheckbox.checked,
    wrap: wrapCheckbox.checked
  });
});
button3.addEventListener("click", () => {
  modal.modal(modal3, {
    hoist: hoistCheckbox.checked,
    useHiddenProperty: hiddenCheckbox.checked,
    wrap: wrapCheckbox.checked
  });
});
unmodalButton.addEventListener("click", () => {
  modal.unmodal();
});